"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerQuestionWidget = void 0;
var React = require("react");
var moment = require("moment");
var QuestionWidgetBase_1 = require("./QuestionWidgetBase");
var react_calendar_1 = require("react-calendar");
var reactstrap_1 = require("reactstrap");
var journey_model_1 = require("@athena-portal/journey-model");
var DatePickerQuestionWidget = exports.DatePickerQuestionWidget = /** @class */ (function (_super) {
    __extends(DatePickerQuestionWidget, _super);
    function DatePickerQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        var dateString = _this.bindFromField(_this.props.question.interactionField);
        var input = _this.inputFromDate(dateString);
        var date = moment(dateString).isValid() ? moment(dateString).toDate() : undefined;
        _this.state = {
            date: date,
            calendarOpen: false,
            input: input
        };
        _this.inputRef = React.createRef();
        _this.containerRef = React.createRef();
        _this.handleCalendarOnChange = _this.handleCalendarOnChange.bind(_this);
        _this.toggleCalendar = _this.toggleCalendar.bind(_this);
        _this.handleInputOnChange = _this.handleInputOnChange.bind(_this);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
        return _this;
    }
    DatePickerQuestionWidget.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var interactionDate = this.bindFromField(this.props.question.interactionField);
        if (interactionDate
            && moment(interactionDate).isValid()
            && !moment(this.state.date).isSame(moment(interactionDate))) {
            var newDate = moment(interactionDate).toDate();
            this.setState({ date: newDate, input: this.inputFromDate(newDate) });
        }
    };
    DatePickerQuestionWidget.prototype.renderInputField = function () {
        return (React.createElement("div", { className: "input-group ".concat(this.getSetting("cssClass")), ref: this.containerRef, onClick: this.handleOnClick, onBlur: this.handleOnBlur, onKeyDown: this.handleOnKeyDown },
            React.createElement("input", { type: "text", autoComplete: "off", className: "form-control ".concat(this.getInputValidationClass()), value: this.state.input, id: this.props.question.name, placeholder: this.props.question.placeHolder, ref: this.inputRef, readOnly: this.isReadOnly(), onChange: this.handleInputOnChange }),
            React.createElement(reactstrap_1.Popover, { placement: "bottom", isOpen: this.state.calendarOpen, container: this.containerRef, target: this.props.question.name, toggle: this.toggleCalendar },
                React.createElement(react_calendar_1.default, { onChange: this.handleCalendarOnChange, value: this.state.date, showFixedNumberOfWeeks: true, minDetail: "decade", prevLabel: (React.createElement("i", { className: "far fa-chevron-left" })), prev2Label: (React.createElement("i", { className: "far fa-chevron-double-left" })), nextLabel: (React.createElement("i", { className: "far fa-chevron-right" })), next2Label: (React.createElement("i", { className: "far fa-chevron-double-right" })) })),
            React.createElement("div", { className: "input-group-prepend" },
                React.createElement("span", { className: "input-group-text" },
                    React.createElement("i", { className: "fas fa-calendar" })))));
    };
    DatePickerQuestionWidget.prototype.handleInputOnChange = function (event) {
        if (event.target.value === "") {
            this.setState({ input: event.target.value });
            this.props.onStateChange(this.props.question.interactionField, event.target.value);
        }
        else {
            var valueMoment = this.getUtcMoment(event.target.value, this.getSetting("format") || "DD/MM/YYYY");
            var date = valueMoment.isValid() ? valueMoment.toDate() : this.state.date;
            this.setState({ date: date, input: event.target.value });
            this.props.onStateChange(this.props.question.interactionField, date.toISOString());
        }
    };
    DatePickerQuestionWidget.prototype.handleCalendarOnChange = function (date) {
        date = this.getUtcMoment(date).toDate();
        this.setState({ date: date, input: this.inputFromDate(date), calendarOpen: false });
        this.props.onStateChange(this.props.question.interactionField, date.toISOString());
    };
    DatePickerQuestionWidget.prototype.handleOnClick = function (event) {
        this.setState({ calendarOpen: true });
    };
    DatePickerQuestionWidget.prototype.handleOnBlur = function (event) {
        if (this.containerRef.current.contains(event.relatedTarget)) {
            this.inputRef.current.focus();
        }
        else {
            this.setState({
                calendarOpen: false,
                input: this.inputFromDate(this.bindFromField(this.props.question.interactionField))
            });
            _super.prototype.handleOnBlurEvent.call(this, event);
        }
    };
    DatePickerQuestionWidget.prototype.handleOnKeyDown = function (event) {
        if (event.key === "Tab") {
            this.setState({
                calendarOpen: false,
                input: this.inputFromDate(this.bindFromField(this.props.question.interactionField))
            });
        }
    };
    DatePickerQuestionWidget.prototype.toggleCalendar = function () {
        this.setState({ calendarOpen: !this.state.calendarOpen });
    };
    DatePickerQuestionWidget.prototype.inputFromDate = function (date) {
        return (!date) ? "" : this.getUtcMoment(date).format(this.getSetting("format", "DD/MM/YYYY"));
    };
    DatePickerQuestionWidget.prototype.getUtcMoment = function (date, format) {
        var utcMoment = (format === undefined) ? moment(date) : moment(date, format);
        return utcMoment.add(utcMoment.utcOffset(), "m").utcOffset(0);
    };
    DatePickerQuestionWidget = __decorate([
        (0, journey_model_1.event)(journey_model_1.Event.onChange),
        (0, journey_model_1.settings)([
            { name: "cssClass", type: journey_model_1.TypeDescriptions.CssClass },
            { name: "format", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], DatePickerQuestionWidget);
    return DatePickerQuestionWidget;
}(QuestionWidgetBase_1.QuestionWidgetBase));
//# sourceMappingURL=DatePickerQuestionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/input/DatePickerQuestionWidget.js
// module id = 2339
// module chunks = 0